import React, { FormEvent } from 'react';
import { RouteComponentProps } from 'react-router';
import {
  FormBuilder, Validators, FieldGroup, FieldControl
} from 'react-reactive-form';
import { ThunkDispatch } from 'redux-thunk';
import { connect } from 'react-redux';
import { TextInput, PasswordInput } from '../../../components/forms/Input';
import { AuthenticationActionTypes } from '../types/authentication.types';
import { AppState } from '../../../store/store.types';
import { performLogin } from '../actions/authentication.action';
import logo from '../../../assets/img/RateChain-logo.svg';

interface LoginProps extends RouteComponentProps {
  login: (username: string, password: string) => void;
  token: string | null;
  loginFailed: boolean;
}

class Login extends React.PureComponent<LoginProps> {

  form = FormBuilder.group({
    username: [ '', Validators.required ],
    password: [ '', Validators.required ]
  });

  componentDidMount() {
    const token = localStorage.getItem('token');
    if (token) {
      this.props.history.push('/reservations');
    }
  }

  componentDidUpdate() {
    if (this.props.token) {
      this.props.history.push('/reservations');
    }
  }

  onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (this.form.valid) {
      this.props.login(this.form.value.username, this.form.value.password);
    }
  };

  render() {
    return (
      <>
        <main>
          <div className="login-container col-4 offset-4">
            <div className="col-8 offset-2 mb-1">
              <img className="login-image" alt="Rate-chain" src={logo} />
            </div>
            {this.props.loginFailed && (
            <div className="alert alert-danger">
              Wrong username or password
            </div>
            )}
            <FieldGroup
              control={this.form}
              render={() => (
                <form className="mt-4" onSubmit={this.onSubmit}>
                  <div className="form-row">
                    <div className="col-8 offset-2">
                      <label>Username / Email</label>
                      <FieldControl
                        name="username"
                        render={TextInput}
                      />
                    </div>
                  </div>
                  <div className="form-row mt-1">
                    <div className="col-8 offset-2">
                      <label>Password</label>
                      <FieldControl
                        name="password"
                        render={PasswordInput}
                      />
                    </div>
                  </div>
                  <div className="form-row mt-2">
                    <div className="col-8 offset-2">
                      <button name="login" type="submit" className="btn btn-primary btn-full-size" disabled={!this.form.valid}>LOGIN</button>
                      <div className="d-flex justify-content-center mt-2">
                        <button onClick={() => { this.props.history.push('/forgotpassword'); }} name="forgot password" type="button" className="btn btn-primary btn-text-only">Forgot your password ?</button>
                      </div>
                    </div>
                  </div>
                </form>
              )}
            />
          </div>
        </main>
      </>
    );
  }
}
const mapStateToProps = (state: AppState) => ({
  token: state.authentication.token,
  loginFailed: state.authentication.loginFailed,
  suppliers: state.authentication.suppliers,
  activeSupplier: state.authentication.activeSupplier
});
const mapDispatchToProps = (
  dispatch: ThunkDispatch<{}, {}, AuthenticationActionTypes>
) => ({
  login: (username: string, password: string) => dispatch(performLogin(username, password)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
